import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import SiteHeader from '../SiteHeader/SiteHeader';
import FromToPayeeSelector from '../FromToPayeeSelector';
import { searchMinimumLength } from '../../config';
import { fromAccountPropType, toAccountPropType } from '../../states/accounts/propTypes';
import { payeePropTypes } from '../PayeeList/propTypes';
import { getToAccounts } from '../../states/accounts/selectors';
import { goToPage } from '../../states/page/actions';
import { getSelectedFromAccount, getSelectedPaymentId } from '../../states/payeeSelector/selectors';
import { setSelectedFromAccount } from '../../states/payeeSelector/actions';
import withAccountSelection from '../../containers/withAccountSelection';
import { getIsLCV } from '../../states/modes/selectors';
import { setLCVAccounts } from '../../states/accounts/actions';
import { setPagingLayoutType, setShowPayees } from '../../states/accountPaging/actions';
import { PAYEE_PICKER_LAYOUT } from '../../pickerLayout/constants';
import { setPayees, removePayee } from '../../states/payees/actions';
import { getPayeePickerBackPage } from '../../states/page/selectors';

const mapState = (state, props) => ({
	selectedPaymentId: getSelectedPaymentId(state),
	selectedFromAccount: getSelectedFromAccount(state),
	toAccounts: getToAccounts(state, props.toAccountFilter),
	fromAccount: getSelectedFromAccount(state),
	getIsLCV: getIsLCV(state),
	payeePickerBackPage: getPayeePickerBackPage(state),
});

const mapDispatch = (dispatch) => ({
	handleCancelPayeeSelect: (page) => dispatch(goToPage(page)),
	setSelectedFromAccount: (fromAccount) => dispatch(setSelectedFromAccount(fromAccount)),
	setLCVAccountsInAccountList: (accounts) => dispatch(setLCVAccounts(accounts)),
	setPagingLayoutType: (layoutType) => dispatch(setPagingLayoutType(layoutType)),
	setPayees: (payees) => dispatch(setPayees(payees)),
	removePayee: (payees) => dispatch(removePayee(payees)),
	setShowPayees: (payees) => dispatch(setShowPayees(payees)),
});

class PayeesPage extends Component {
	constructor(props) {
		super(props);

		this.onPayeeListContinue = this.onPayeeListContinue.bind(this);
	}
	componentDidMount() {
		const { setPagingLayoutType } = this.props;
		setPagingLayoutType(PAYEE_PICKER_LAYOUT);
	}

	componentWillUnmount() {
		const { setPagingLayoutType, setShowPayees } = this.props;
		setPagingLayoutType('');
		setShowPayees(true);
	}

	onPayeeListContinue(selectedToPayees) {
		this.props.onPayeeListContinue(selectedToPayees);
	}

	render() {
		const {
			toPayees,
			fromAccounts,
			header,
			description,
			content,
			handleCancelPayeeSelect,
			handleDisplayFullwidth,
			selectedPaymentId,
			paymentCount,
			canPayBeneficiaries,
			fromAccount,
			toAccount,
			toAccounts,
			showAccounts,
			mode,
			showFromAccountSelector,
			handleSelectFromAccount,
			handleFromCardClick,
			getIsLCV,
			setLCVAccountsInAccountList,
			setPayees,
			removePayee,
			payeePickerBackPage,
			paymentLimit,
		} = this.props;

		const wrapperClass = classnames({
			'c-o-payee-list--from-state': showFromAccountSelector,
		});

		const filteredToAccounts = toAccounts.filter((account) => fromAccount !== account.id);

		return (
			<div className={wrapperClass}>
				<SiteHeader title={header} description={description} />

				<FromToPayeeSelector
					fromAccount={fromAccount}
					fromAccounts={fromAccounts} // TODO: this is passed but unused
					toAccount={toAccount}
					handleDisplayFullwidth={handleDisplayFullwidth}
					handleSelectFromAccount={handleSelectFromAccount}
					handleFromCardClick={handleFromCardClick}
					showFromAccountSelector={showFromAccountSelector}
					toPayees={toPayees}
					content={content}
					onPayeeListContinue={this.onPayeeListContinue}
					payees={toPayees}
					showBeneficiaries={!!toPayees.length}
					canAddMultiplePayments={!selectedPaymentId}
					searchMinimumLength={searchMinimumLength}
					handleCancelPayeeSelect={() => handleCancelPayeeSelect(payeePickerBackPage)}
					paymentLimit={paymentLimit}
					showAddPayeeButton={canPayBeneficiaries}
					selectedPaymentId={selectedPaymentId}
					showAccounts={showAccounts && toAccounts.length > 0}
					toAccounts={filteredToAccounts}
					currentPaymentCount={paymentCount}
					isLargeCustomerView={getIsLCV}
					setLCVAccountsInAccountList={setLCVAccountsInAccountList}
					setPayees={setPayees}
					removePayee={removePayee}
					paymentMode={mode}
				/>
			</div>
		);
	}
}

PayeesPage.defaultProps = {
	canPayBeneficiaries: true,
	mode: 'payment',
	paymentLimit: 150,
};

PayeesPage.propTypes = {
	content: PropTypes.shape({}).isRequired,
	fromAccounts: PropTypes.arrayOf(PropTypes.shape(fromAccountPropType)).isRequired,
	toPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)).isRequired,
	handleCancelPayeeSelect: PropTypes.func.isRequired,
	selectedPaymentId: PropTypes.string,
	paymentCount: PropTypes.number.isRequired,
	toAccounts: PropTypes.arrayOf(PropTypes.shape(toAccountPropType)).isRequired,
	onPayeeListContinue: PropTypes.func.isRequired,
	canPayBeneficiaries: PropTypes.bool,
	toAccount: PropTypes.string,
	fromAccount: PropTypes.string,
	header: PropTypes.string,
	description: PropTypes.string,
	showAccounts: PropTypes.bool,
	mode: PropTypes.string,
	showFromAccountSelector: PropTypes.bool.isRequired,
	handleSelectFromAccount: PropTypes.func.isRequired,
	handleFromCardClick: PropTypes.func.isRequired,
	getIsLCV: PropTypes.bool.isRequired,
	setLCVAccountsInAccountList: PropTypes.func,
	setPagingLayoutType: PropTypes.func.isRequired,
	setPayees: PropTypes.func.isRequired,
	removePayee: PropTypes.func.isRequired,
	payeePickerBackPage: PropTypes.string.isRequired,
	paymentLimit: PropTypes.number,
	setShowPayees: PropTypes.func.isRequired,
	handleDisplayFullwidth: PropTypes.func,
};

export default connect(mapState, mapDispatch)(withAccountSelection(PayeesPage));
